"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromotionsProvider = void 0;
exports.usePromotionsData = usePromotionsData;
exports.usePromotionsState = usePromotionsState;
exports.usePromotionsActions = usePromotionsActions;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const get_1 = __importDefault(require("lodash/get"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const reducer_1 = __importDefault(require("./context/reducer"));
const actions_1 = __importDefault(require("./context/actions"));
// TODO: find better way to handle hardcoded config data into bit
const promotions_utils_1 = require("./promotions.utils");
const DataContext = (0, react_1.createContext)();
const StateContext = (0, react_1.createContext)();
const ActionsContext = (0, react_1.createContext)();
/* Currently components are dependent on specific value discount data keys existing (e.g. adjustableBaseMattress, foundationMattress, etc) so we need a fallback in case the promotion
data fetch fails */
const NO_DISCOUNT = {
    discountValue: 0,
    discountedProductSkus: []
};
const fallbackValueDiscounts = {
    nightstands: NO_DISCOUNT,
    bedFramesMattress: NO_DISCOUNT,
    foundationMattress: NO_DISCOUNT,
    adjustableBaseMattress: NO_DISCOUNT,
    pillowPair: NO_DISCOUNT // NOTE that pillow pairs values are still currently populated by global config on PDPs and Sale page but NOT in BundleDP strike-through
};
const PromotionsProvider = ({ children, contextData }) => {
    const { hideBanner, isValueDiscountEligible, valueDiscounts, cartPriceDiscounts, sitewideModifier, isPLA, surplusDiscounts, sitewidePromoData, prefixIds } = contextData;
    if (sitewidePromoData) {
        const { sitewideName, couponCode, fixedAmounts } = sitewidePromoData;
        const isCouponPromo = Boolean(couponCode);
        const isBMSMPromo = sitewideName === ('bmsm_sitewide');
        const isPercentagePromo = sitewideName === ('percent_sitewide');
        const isFixedPromo = sitewideName === ('fixed_sitewide') || Boolean(fixedAmounts);
        const isBMSMFixedMattress = sitewideName === ('bmsm_and_fixed_mattress_sitewide');
        const isChooseYourDealPromo = sitewideName === ('choose_your_deal_promo');
        const isNoSale = sitewideName === ('no_sale');
        // TODO: udpate to single string if possible if we can refactor out of switch cases in dependent components
        const promoProfile = {
            isCouponPromo,
            isBMSMPromo,
            isPercentagePromo,
            isBMSMFixedMattress,
            isChooseYourDealPromo,
            isFixedPromo,
            isNoSale
        };
        sitewidePromoData.fixedDiscountAmount = (0, get_1.default)(sitewidePromoData, ['fixedAmounts', 0, 0]);
        sitewidePromoData.fixedDiscountThreshold = (0, get_1.default)(sitewidePromoData, ['fixedAmounts', 0, 1]);
        sitewidePromoData.promoProfile = promoProfile;
        sitewidePromoData.pagesMessaging = (0, promotions_utils_1.getSitewideMessaging)(sitewidePromoData);
        sitewidePromoData.discountSku = sitewidePromoData.bmsmMattress || sitewidePromoData.percentMattress;
    }
    const data = {
        sitewidePromo: sitewidePromoData,
        hideBanner,
        isValueDiscountEligible,
        /*  TODO: components should be less dependent on specific value discounts (e.g. adjustableBaseMattress, foundationMattress, etc) */
        valueDiscountDefinitions: !(0, isEmpty_1.default)(valueDiscounts) ? valueDiscounts : fallbackValueDiscounts,
        surplusDiscountDefinitions: surplusDiscounts,
        cartPriceDiscounts,
        sitewideModifier,
        isPLA,
        prefixIds
    };
    const initialState = {
        isValueDiscountEligible,
        valueDiscounts,
        cartPriceDiscounts, // currently just the "included discounts" (ex. crib + crib sheet)
        cartPriceDiscountTotal: 0
    };
    const staticData = (0, react_1.useMemo)(() => data, [contextData]);
    const [state, dispatch] = (0, react_1.useReducer)(reducer_1.default, initialState);
    return ((0, jsx_runtime_1.jsx)(DataContext.Provider, { value: staticData, children: (0, jsx_runtime_1.jsx)(StateContext.Provider, { value: state, children: (0, jsx_runtime_1.jsx)(ActionsContext.Provider, { value: dispatch, children: children }) }) }));
};
exports.PromotionsProvider = PromotionsProvider;
function usePromotionsData() {
    const data = (0, react_1.useContext)(DataContext);
    if (typeof data === 'undefined') {
        throw new Error('usePromotionsData must be used within PromotionsProvider');
    }
    return data;
}
function usePromotionsState() {
    const state = (0, react_1.useContext)(StateContext);
    if (typeof state === 'undefined') {
        throw new Error('usePromotionsState must be used within PromotionsProvider');
    }
    return state;
}
function usePromotionsActions() {
    const dispatch = (0, react_1.useContext)(ActionsContext);
    if (typeof dispatch === 'undefined') {
        throw new Error('usePromotionsActions must be used within PromotionsProvider');
    }
    const actions = (0, react_1.useMemo)(() => (0, actions_1.default)(dispatch), [dispatch]);
    return actions;
}
// add display name for dev tool readability
PromotionsProvider.displayName = 'PromotionsContext';
DataContext.displayName = 'PromotionsData';
StateContext.displayName = 'PromotionsState';
ActionsContext.displayName = 'PromotionsActions';
PromotionsProvider.propTypes = {
    children: prop_types_1.default.any,
    contextData: prop_types_1.default.shape({
        sitewidePromoData: prop_types_1.default.object,
        hideBanner: prop_types_1.default.bool,
        isValueDiscountEligible: prop_types_1.default.bool,
        valueDiscounts: prop_types_1.default.object,
        cartPriceDiscounts: prop_types_1.default.object,
        sitewideModifier: prop_types_1.default.string,
        isPLA: prop_types_1.default.bool,
        prefixIds: prop_types_1.default.array
    })
};
//# sourceMappingURL=promotions.context.js.map